// utils/auth.js
export const handleUnauthorized = () => {
  localStorage.removeItem("astroVani-admin-token");
  localStorage.removeItem("astroVani-admin-data");
  window.location.href = "/sign-in"; 
};
